export enum Situation {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}